import { render, staticRenderFns } from "./gradientHeader.vue?vue&type=template&id=b0e28a18&scoped=true&"
import script from "./gradientHeader.vue?vue&type=script&lang=js&"
export * from "./gradientHeader.vue?vue&type=script&lang=js&"
import style0 from "./gradientHeader.vue?vue&type=style&index=0&id=b0e28a18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e28a18",
  null
  
)

export default component.exports